import React from 'react';

const variants = {
  error:
    'bg-red-50 dark:bg-red-900/30 border-red-300 dark:border-red-800 text-red-700 dark:text-red-300',
  warning:
    'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-300 dark:border-yellow-800 text-yellow-800 dark:text-yellow-300',
  success:
    'bg-green-50 dark:bg-green-900/20 border-green-300 dark:border-green-800 text-green-700 dark:text-green-300',
  info: 'bg-brand-50 dark:bg-brand-900/20 border-brand-300 dark:border-brand-700 text-brand-800 dark:text-brand-200',
};

const icons = {
  error: 'M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z',
  warning:
    'M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z',
  success:
    'M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z',
  info: 'M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z',
};

/**
 * Centralised alert. Generalises the old error-only ErrorMessage.
 * ErrorMessage is kept as a thin compat wrapper.
 */
export function Alert({ variant = 'error', title, children, message, className = '', ...props }) {
  const body = children ?? message;
  if (!body && !title) return null;
  const variantClasses = variants[variant] || variants.error;

  return (
    <div
      role={variant === 'error' ? 'alert' : 'status'}
      className={`border px-4 py-3 rounded-lg mb-4 ${variantClasses} ${className}`}
      {...props}
    >
      <div className="flex items-start">
        <svg className="w-5 h-5 mr-2 mt-0.5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20" aria-hidden>
          <path fillRule="evenodd" d={icons[variant] || icons.error} clipRule="evenodd" />
        </svg>
        <div className="min-w-0">
          {title && <p className="font-semibold mb-0.5">{title}</p>}
          {body && <div className="text-sm">{body}</div>}
        </div>
      </div>
    </div>
  );
}

export default Alert;
